export const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";

export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem("token");

  const headers = { ...(options.headers || {}) };

  // Nu seta Content-Type pentru FormData — browser-ul îl setează automat cu boundary
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const msg = data?.detail || "Eroare API";
    throw new Error(msg);
  }

  return data;
}
